import type { EmailThreadDto, GetEmailThreadOutput } from 'korint-sdk';
import { uniqBy } from 'lodash';

export type PinnedThread = { view: string; index: number; thread: EmailThreadDto };

const refreshedFrom = (
  thread: EmailThreadDto,
  { emails, analysisPending }: GetEmailThreadOutput,
) => ({
  ...thread,
  analysisPending,
  isUnread: false,
  isArchived: emails.every(({ isArchived }) => isArchived),
  emailCount: emails.length,
  toProcessCount: emails.filter(({ isToProcess }) => isToProcess).length,
  linkedPolicies: uniqBy(
    emails.flatMap(({ linkedPolicies }) => linkedPolicies),
    ({ id }) => id,
  ),
});

export const keepOpenedThread = ({
  threads,
  pinned,
  view,
  detail,
}: {
  threads: EmailThreadDto[];
  pinned: PinnedThread | null;
  view: string;
  detail: GetEmailThreadOutput | undefined;
}) => {
  if (!pinned || pinned.view !== view || threads.some(({ id }) => id === pinned.thread.id)) {
    return threads;
  }
  const thread =
    detail?.id === pinned.thread.id ? refreshedFrom(pinned.thread, detail) : pinned.thread;
  const index = Math.min(pinned.index, threads.length);
  return [...threads.slice(0, index), thread, ...threads.slice(index)];
};
